const VERDICT_LABELS = {
  PASS: "Conforme",
  REVIEW: "À vérifier",
  FAIL: "Non conforme",
};

const FIELD_LABELS = {
  documentType: "Type de document",
  declarantName: "Nom du déclarant",
  description: "Description des faits",
  location: "Lieu des faits",
  incidentDate: "Date des faits",
  theftQualification: "Qualification vol",
  imei: "IMEI",
};

const DOCUMENT_TYPE_LABELS = {
  complaints_receipt: "Procès-verbal de dépôt de plainte",
  complaints_receipt_acknowledgment: "Récépissé d'enregistrement",
  other: "Autre",
};

export function verdictLabel(verdict) {
  return VERDICT_LABELS[verdict] || verdict || "—";
}

export function badgeClassFor(verdict) {
  switch (verdict) {
    case "PASS":
      return "bg-green-100 text-green-800";
    case "REVIEW":
      return "bg-yellow-100 text-yellow-800";
    case "FAIL":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-700";
  }
}

export function mapExtractedFields(analysis) {
  const extracted = analysis?.extracted;
  if (!extracted) return {};
  const fields = {
    Type: DOCUMENT_TYPE_LABELS[extracted.documentType] || extracted.documentType,
    "Nom déclarant": extracted.declarantName,
    Description: extracted.description,
    Lieu: extracted.location,
    "Date des faits": extracted.incidentDate,
    IMEI: extracted.imei,
  };
  return Object.fromEntries(Object.entries(fields).filter(([, value]) => value !== "" && value != null));
}

export function mapChecks(analysis) {
  const rawChecks = analysis?.checks;
  if (!rawChecks) return [];
  return Object.entries(rawChecks).map(([field, data]) => ({
    field,
    label: FIELD_LABELS[field] || field,
    verdict: data?.verdict,
    reason: data?.reason,
  }));
}

export function formatAnalyzedAt(analyzedAt) {
  if (!analyzedAt) return "";
  return new Date(analyzedAt).toLocaleString("fr-FR");
}
